<template>
  <div>
    <ProductHeader header="เพิ่มสินค้า" :img_header="header_image" :link_back="$store.state.link_url"/>
    <Product_add/>
  </div>
</template>

<script>
import HeaderImage from "@/assets/box_1.png";
import ProductHeader from "@/components/admin/manage_products/header_products/ProductHeader.vue";
import Product_add from "@/components/admin/manage_products/Product_add.vue";
export default {
  name: "ProductAdd",
  components: {
    Product_add,
    ProductHeader,
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
